<div class="container" fxLayout="row" fxLayoutAlign="center none">

  <div fxFlex="95%">
    <div class="container" fxLayout="row" fxLayoutAlign="center none">

      <h2>Welcome back, {{currentUser.fullName}}!</h2>

    </div>

    <div class="container" fxLayout="row" fxLayoutAlign="center none">
      <div fxFlex="50%" class="text-center no-records animate">
        <mat-icon>dashboard</mat-icon>
        <p>This is the dashboard.</p>
      </div>
      <mat-icon> </mat-icon>
    </div>
  </div>
</div>